export default {
  noDrivers: 'Este pedido lleva mucho tiempo sin que lo tomen',
  noDriverData: 'No hay información del repartidor',
  driverNotMoving: 'El repartidor no se esta moviendo',
  lateAtPoint: 'El pedido esta con retraso',
  driverIsNew: 'El repartidor es nuevo',
  driverMovingWrongWay: 'El repartidor va en sentido contrario',
  mockLocation: 'El repartidor tiene GPS falso',
  noNearDrivers: 'No hay repartidores cerca',
  driverPhotoFaceNotDetected: 'La foto del conductor no coincide con la foto del perfil',
  eaterIsComplaining: 'El cliente esta reclamando',
  websiteIsComplaining: 'La marca esta reclamando',

}
